import ArticlesApi from '../../api/Articles';
import { ERROR_TYPES } from '../../constants/ApiErrorConstants';
import { isDomainNotConnectedError, isVariationCategoryNotSynced } from '../../utils/publishArticleError';
import * as ActionTypes from '../ActionTypes';
import { showArticlePublishDomainNotResolvingErrorNotification, showArticlePublishVariationCategoryNotSyncedErrorNotification, showErrorNotification, showErrorNotificationWithMessage } from '../Notifications';
function articlePublished() {
  return {
    type: ActionTypes.PUBLISH_ARTICLE_SUCCESS
  };
}
function articlePublishing() {
  return {
    type: ActionTypes.PUBLISH_ARTICLE_PENDING
  };
}
function articlePublishRequestFailed(error) {
  return {
    error,
    type: ActionTypes.PUBLISH_ARTICLE_ERROR
  };
}
export function publishArticle(articleId) {
  return dispatch => {
    dispatch(articlePublishing());
    return ArticlesApi.publish(articleId).then(() => {
      dispatch(articlePublished());
    }, error => {
      dispatch(articlePublishRequestFailed(error));
      if (error.responseJSON && ERROR_TYPES.SLUG_CONFLICT_ERROR_TYPES.includes(error.responseJSON.errorType)) {
        dispatch(showErrorNotificationWithMessage('publishArticle', error.responseJSON.message));
      } else if (isDomainNotConnectedError(error)) {
        dispatch(showArticlePublishDomainNotResolvingErrorNotification());
      } else if (isVariationCategoryNotSynced(error)) {
        dispatch(showArticlePublishVariationCategoryNotSyncedErrorNotification());
      } else {
        dispatch(showErrorNotification('publishArticle'));
      }
      return Promise.reject(error);
    });
  };
}
export function prePublishArticle() {
  return {
    type: ActionTypes.PRE_PUBLISH_ARTICLE
  };
}